import axios from "axios";
import { getCookie } from "@/util/help.js";
let token = getCookie('OKMSID_DEV_1');

const instance = axios.create({});
const CancelToken = axios.CancelToken;
const source = CancelToken.source();

// 请求拦截
instance.interceptors.request.use(
  function (config) {

    // 全局添加calcelToken
    config.cancelToken = source.token;

    // 全局添加headers
    config.headers['Content-Type'] = 'application/json';
    if (token) {
      // config.headers['Authorization'] = `Bearer ${token}`;
      // config.headers['Cookie'] = `OKMSID_DEV_1=${token}`;
    }

    if (config.url != '/searchStandard' && !config.url.includes("cajToPdf/convert") && !config.url.includes('oauthLogin') && !config.url.includes('jkrd/api') && !config.url.includes('zk') && !config.url.includes('api') && config.url != '/source' && config.url != '/jt') {
      config.baseURL = '/okmsApi'
    }
    if(config.header){
        for(let key in config.header){
            config.headers[key] = config.header[key];
        }
    }
    return config;
  },
  function (error) {
    return false;
  }
);
// 响应拦截
instance.interceptors.response.use(
  function (response) {
    if (response.status == 200) {
      return response.data;
    }
  },
  function (error) {
    let code = error.response.status;
    if (code == 400) {
      if (error.response.config.url == '/swchat/chat/checkQuestionText' || error.response.config.url == '/swchat/web/dialog-topic/addSingle') {
        return error.response.data
      }
    } else if (code == 401) {
      // 未登录
      window.location.href = `${window.location.origin}?returnUrl=/nz_sw`
    } else {
      return Promise.reject(error.response.data ? error.response.data : {});
    }
  }
);

export default instance;
